/*
 * Logo de cada marca del catálogo (public/img/marcas/, generados con
 * scripts/logos-marcas.mjs; fuentes y licencias en CREDITOS.md).
 *
 * El nombre de la marca se normaliza para tolerar cómo están capturadas en
 * la base: espacios de más, acentos y variantes ("VW", "VOLKSWAGUEN").
 * Sin logo conocido → null (la pantalla muestra iniciales).
 */
export const LOGOS_DISPONIBLES = [
  'acdelco', 'acura', 'audi', 'autozone', 'beru', 'bmw', 'boge', 'bosch', 'buick', 'cadillac', 'chevrolet',
  'chrysler', 'federal-mogul', 'fiat', 'ford', 'freightliner', 'gmc', 'hella', 'hino', 'honda', 'hummer',
  'hyundai', 'isuzu', 'jeep', 'kia', 'kyb', 'land-rover', 'lexus', 'lincoln', 'mahle', 'mazda', 'mercedes-amg',
  'mercedes-benz', 'mercury', 'michelin', 'mitsubishi', 'mobil', 'mopar', 'motorcraft', 'nissan', 'ntn', 'pemex',
  'peugeot', 'pontiac', 'renault', 'sachs', 'seat', 'skf', 'subaru', 'suzuki', 'toyota', 'valeo', 'valvoline',
  'volkswagen', 'volvo', 'wd-40',
]

// Cómo aparece en la base → archivo del logo
const VARIANTES = {
  vw: 'volkswagen',
  volkswaguen: 'volkswagen',
  cadilac: 'cadillac',
  mercedes: 'mercedes-benz',
  amg: 'mercedes-amg',
  micheline: 'michelin',
  sach: 'sachs',
  bogge: 'boge',
  'duralast-autozone': 'autozone',
  duralast: 'autozone',
}

const DISPONIBLES = new Set(LOGOS_DISPONIBLES)

/* "MERCEDES BENZ " → "mercedes-benz"; "WD-40" → "wd-40". */
export function claveDeMarca(nombre) {
  return String(nombre ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
}

/* URL del logo de la marca, o null si no tenemos uno. */
export function logoDeMarca(nombre) {
  const clave = claveDeMarca(nombre)
  const archivo = VARIANTES[clave] || clave
  if (!DISPONIBLES.has(archivo)) return null
  const base = (typeof process !== 'undefined' && process.env && process.env.BASE_URL) || '/'
  return `${base}img/marcas/${archivo}.png`
}
